<template>
  <b-card class="h-100" title="Финансы и игры по неделям">
    <vue-apex-charts v-if="safePoints.length" type="line" height="340" :options="chartOptions" :series="series" />
    <div v-else class="text-center text-muted py-4">Нет данных</div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { computed } from '@vue/composition-api'
import { $themeColors } from '@themeConfig'
import { formatRub } from '@/views/finance/utils'

export default {
  components: { BCard, VueApexCharts },
  props: {
    points: { type: Array, default: () => [] },
  },
  setup(props) {
    // props.points может прийти как null (страница передаёт `data.business && data.business.points`) —
    // Vue не подставляет default для явного null, поэтому нормализуем через computed.
    // Названа не `points`, а `safePoints`: @vue/composition-api не проксирует на инстанс
    // setup-биндинг с тем же именем, что и уже объявленный prop (только предупреждает в консоль),
    // так что шаблон продолжил бы читать «сырой» (возможно null) prop.
    const safePoints = computed(() => props.points || [])

    const series = computed(() => [
      { name: 'Выручка', type: 'line', data: safePoints.value.map(p => p.revenue) },
      { name: 'Расходы', type: 'line', data: safePoints.value.map(p => p.expenses) },
      { name: 'Прибыль', type: 'line', data: safePoints.value.map(p => p.profit) },
      { name: 'Игр', type: 'column', data: safePoints.value.map(p => p.games_count) },
    ])

    const chartOptions = computed(() => ({
      chart: { toolbar: { show: false }, stacked: false },
      colors: [$themeColors.success, $themeColors.danger, $themeColors.primary, $themeColors.secondary],
      stroke: { curve: 'smooth', width: [2, 2, 3, 0] },
      fill: { opacity: [1, 1, 1, 0.25] },
      markers: { size: 3 },
      plotOptions: { bar: { columnWidth: '35%', borderRadius: 3 } },
      xaxis: {
        categories: safePoints.value.map(p => p.week_name),
        labels: { rotate: -30, style: { fontSize: '11px' } },
      },
      yaxis: [
        { seriesName: 'Выручка', labels: { formatter: val => formatRub(val) } },
        { seriesName: 'Выручка', show: false },
        { seriesName: 'Выручка', show: false },
        { opposite: true, seriesName: 'Игр', title: { text: 'Игр' }, labels: { formatter: val => Math.round(val) }, min: 0 },
      ],
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: (val, { seriesIndex }) => (seriesIndex === 3 ? `${val} игр` : formatRub(val)),
        },
      },
      legend: { position: 'top' },
    }))

    return {
      safePoints, series, chartOptions,
    }
  },
}
</script>
